import { render, staticRenderFns } from "./psychologist_consultation.vue?vue&type=template&id=844b0fae&scoped=true"
import script from "./psychologist_consultation.vue?vue&type=script&lang=js"
export * from "./psychologist_consultation.vue?vue&type=script&lang=js"
import style0 from "./psychologist_consultation.vue?vue&type=style&index=0&id=844b0fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844b0fae",
  null
  
)

export default component.exports